import React, { useContext } from "react";
import TabPosition from "../shared/TabPosition";
import { Helmet } from "react-helmet-async";
import { TranslationService } from "../../services/TranslationService";
import ConsolidatedClientTableProvider from "./providers/ConsolidatedClientTableProvider";
import ConsolidatedClientTableItem from "./components/ConsolidatedClientTableItem";
import ConsolidatedClientFilterContainer from "./components/ConsolidatedClientFilterContainer";
import { TableHeader, default as Table } from "../shared/Table";
import { FixToTop } from "../shared/FixToTop";
import TableContext from "../task/TableContext";
import { formatCurrency } from "../../utils/FormatUtils";
import CompanyService from "../../services/CompanyService";

const ConsolidatedClients: React.FC = () => {
  const { translate } = TranslationService;

  const tableHead: TableHeader[] = [
    new TableHeader("name", translate.Client, false, true, "w-300px"),
    new TableHeader("cant", translate.Invoices, true, true),
    new TableHeader("amount", translate.Amount, true, true),
    new TableHeader("due", translate.Due + "/" + translate.NoDue, false, true)
  ];

  return (
    <TabPosition module="consolidated/clients">
      <Helmet>
        <title>
          Intiza - {translate.Consolidated} - {translate.Clients}
        </title>
      </Helmet>
      <div className="container-fluid padding">
        <div className="card mh-100 p-0">
          <ConsolidatedClientTableProvider>
            <FixToTop>
              <ConsolidatedClientFilterContainer />
            </FixToTop>
            <Table
              headers={tableHead}
              item={ConsolidatedClientTableItem}
              stickyHeader={true}
            >
              <ConsolidatedClientTableTotal />
            </Table>
          </ConsolidatedClientTableProvider>
        </div>
      </div>
    </TabPosition>
  );
};

const ConsolidatedClientTableTotal = () => {
  const { response } = useContext(TableContext);
  const { translate } = TranslationService;
  return (
    <tr className="font-weight-bold" style={{ backgroundColor: "#ddedf9" }}>
      <td>{translate.Total}</td>
      <td className="text-end">{response?.iocount ?? 0}</td>
      <td className="text-end">
        {formatCurrency(
          response?.total ?? 0,
          CompanyService.getDefaultCurrencyId()
        )}
      </td>
      <td></td>
    </tr>
  );
};

export default ConsolidatedClients;
